import { Metadata } from '../../../plugins/MetadataPlugin';
import Tool, { type ToolArgsWithController } from '../../../tools/Tool';

class ToolToggleTableOfContents extends Tool {
  static toolName = 'Table of contents';
  static iconClass = 'fa-regular fa-poll-h';

  static available({ controller }: ToolArgsWithController): boolean {
    return controller.ahaEditor.hasPlugin('TableOfContentsPlugin');
  }

  static isActive({ editor }: ToolArgsWithController): boolean {
    return !!editor.metadata?.tableOfContentsEnabled;
  }

  static action({ editor, controller }: ToolArgsWithController): void {
    Metadata.updateMetadata(editor, {
      key: 'tableOfContentsEnabled',
      value: !editor.metadata?.tableOfContentsEnabled,
    });
  }
}

export default ToolToggleTableOfContents;
